import { EColors } from "common/styles";
import styled from "styled-components";

export const IconArrow = styled.svg`
  width: 36px;
  height: 36px;
  fill:${EColors.white};
  transition:all 0.3s linear;

`;
export const Container = styled.button`
  width: 72px;
  height: 72px;
  background-color: ${EColors.black};
  border: 2px solid;
  border-color:transparent;
  border-radius:50%;
  display:inline-flex;
  align-items: center;
  justify-content:center;
  cursor: pointer;
  transition:all 0.2s linear;
  &:hover{
    border-color:${EColors.accent_300};
  }
  &:hover  ${IconArrow}{
    fill:${EColors.accent_300};
  }
`;



